<template>
    <div id="home" class="px-4 pt-5 mt-5 text-center">
        <h1 class="display-5 fw-bold text-body-emphasis mb-2" style="color: #555555 !important;"> <b>Easy data curation,</b></h1>
        <h1 class="display-5 fw-bold text-body-emphasis mb-3"><b>Fast assessments</b></h1>
        <div class="col-lg-6 mx-auto">
            <p class="lead text-center">
                <b class="read">
                    Store and manage all your appraisal documents online. Update your documents with ease. Submit appraisal documents online. Conduct reviews, assessments and appraisals online. No hassles from dealing with printing and errors.
                </b> 
            </p>
            <div class="mx-5 pt-2">
                <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mt-3">
                    <button v-if="!isLoggedIn" type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4" data-bs-toggle="modal"
                        data-bs-target="#exampleModal1">Get
                        Started</button>
                    <button v-if="!isLoggedIn" type="button" class="btn btn-outline-secondary btn-lg px-4 rounded-4 signInBtn"
                        data-bs-toggle="modal" data-bs-target="#exampleModal2">Sign
                        In</button>
                    <router-link v-if="$store.state.user.staffType == 'Academic Teaching' && isLoggedIn" to="/sectiona">
                        <button type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">Go to Appraisal Form</button>
                    </router-link>
                    <router-link v-if="($store.state.user.staffType == 'Junior Non-academic' || $store.state.user.staffType == 'Senior Non-academic') && isLoggedIn" to="/section1">
                        <button type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">Go to Appraisal Form</button>
                    </router-link>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Register</h1>
                            <button id="close1" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body container px-5">
                            <div class="mb-3">
                                <select v-model="staffType" class="form-control" id="exampleFormControlInput3"
                                    name="Staff Type">
                                    <option selected value="Staff Type">Staff Type</option>
                                    <option value="Academic Teaching">Academic Teaching Staff</option>
                                    <option value="Senior Non-academic">Senior Non-academic Staff</option>
                                    <option value="Junior Non-academic">Junior Non-academic Staff</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <input v-model="email" type="text" class="form-control" id="exampleFormControlInput7"
                                    placeholder="Email">
                            </div>
                            <div class="mb-3">
                                <input type="password" class="form-control" id="exampleFormControlInput3"
                                    placeholder="Password">
                            </div>
                            <div class="mb-3">
                                <input type="password" class="form-control" id="exampleFormControlInput4"
                                    placeholder="Confirm Password">
                            </div>
                        </div>
                        <div class="modal-footer justify-content-center">
                            <button @click="getCandidate('register')" type="button" class="btn btn-success">Register</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Sign In</h1>
                            <button id="close2" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body container px-5">
                            <div class="mb-3">
                                <input v-model="email" type="text" class="form-control" id="exampleFormControlInput5"
                                    placeholder="Email">
                            </div>
                            <div class="mb-3">
                                <input type="password" class="form-control" id="exampleFormControlInput6"
                                    placeholder="Password">
                            </div>
                        </div>
                        <div class="modal-footer justify-content-center">
                            <button @click="getCandidate('login')" type="button" class="btn btn-success">Sign In</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="homeListing">
        <div class="container homeListingContainer">
            <div class="row mx-lg-5">
            <div class="col-sm-6 mb-4 d-flex justify-content-center">
                <div class="card homeCard">
                    <div class="card-body p-4 mx-1">
                        <div style="font-size: 50px; color: silver;">
                            <i class="fa-solid fa-gear p-3 rounded-4 homeCardIcon"></i>
                        </div>
                        <h5 class="card-title mt-4 text-center"><b>Better Productivity</b></h5>
                        <p class="card-text mb-4 text-center">Improve overall organisational productivity by automating staff assessment and appraisal processes.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 mb-4 d-flex justify-content-center">
                <div class="card homeCard">
                    <div class="card-body p-4 mx-1">
                        <div style="font-size: 50px; color: silver;">
                            <i class="fa-solid fa-money-bill p-3 rounded-4 homeCardIcon"></i>
                        </div>
                        <h5 class="card-title mt-4 text-center"><b>Affordable Cost</b></h5>
                        <p class="card-text mb-4 text-center">Save the cost, stress and time of printing, storing and transporting multiple assessment and appraisal documents.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 mb-4 d-flex justify-content-center">
                <div class="card homeCard">
                    <div class="card-body p-4 mx-1">
                        <div style="font-size: 50px; color: silver;">
                            <i class="fa-solid fa-rotate p-3 rounded-4 homeCardIcon"></i>
                        </div>
                        <h5 class="card-title mt-4 text-center"><b>Quick Updates</b></h5>
                        <p class="card-text mb-4 text-center">Update, store and submit various sizes of assessment and appraisal documents rapidly and with ease.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 mb-4 d-flex justify-content-center">
                <div class="card homeCard pb-4">
                    <div class="card-body p-4 mx-1">
                        <div style="font-size: 47px; color: silver;">
                            <i class="fa-solid fa-people-group p-3 rounded-4 homeCardIcon"></i>
                        </div>
                        <h5 class="card-title mt-4 text-center"><b>Easy Collaboration</b></h5>
                        <p class="card-text text-center">Easily collaborate within assessment and appraisal panels by concurrently reviewing staff documents online.</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    <div class="mx-4">
        <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5 mx-5">
            <button v-if="!isLoggedIn" type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4" data-bs-toggle="modal"
                data-bs-target="#exampleModal1">Register</button>
            <button v-if="!isLoggedIn" type="button" class="btn btn-outline-secondary btn-lg px-4 rounded-4 signInBtn"
                data-bs-toggle="modal" data-bs-target="#exampleModal2">Log In</button>
            <router-link v-if="$store.state.user.staffType == 'Academic Teaching' && isLoggedIn" to="/sectiona">
                <button type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">Go to Appraisal Form</button>
            </router-link>
            <router-link v-if="($store.state.user.staffType == 'Junior Non-academic' || $store.state.user.staffType == 'Senior Non-academic') && isLoggedIn" to="/section1">
                <button type="button" class="btn btn-success btn-lg px-4 gap-3 rounded-4">Go to Appraisal Form</button>
            </router-link>
        </div>
    </div>
    <div class="footer" style="padding: 100px;"></div>
    <div class="py-3" style="color: grey;">
        <small>
            &copy;{{ copyrightDate }} <b class="fira">assess.org.ng</b>. All rights reserved.
        </small>     
      </div>
</template>
<script>
import DataService from '../services/dataservice'

export default {
    name: 'home',
    emits: ['toggleLoader'],
    data() {
        return {
            email: '',
            loading: false,
            staffType: 'Staff Type'
        }
    },
    computed: {
        isLoggedIn() {
            return DataService.isLoggedIn();
        },
        copyrightDate() {
            const currentDate = new Date();
            return currentDate.getFullYear();
        }
    },
    methods: {
        async getCandidate(auth) {
            this.$emit('toggleLoader');

            if (auth == 'register') {
                if (this.email) {
                    if (this.staffType == 'Staff Type') {
                        alert('Choose a staff type');
                        this.$emit('toggleLoader');
                        return
                    }
                    this.loading = true;

                    document.getElementById('close1').click();

                    const user = await DataService.register({ email: this.email, staffType: this.staffType });

                    if (user) {
                        this.$store.commit('connect', {_id: user._id, staffType: user.staffType});

                        this.$emit('toggleLoader');

                        if (user.staffType == 'Academic Teaching') {
                            this.$router.push({ path: '/sectiona' });
                        } else {
                            this.$router.push({ path: '/section1' })
                        }
                    } else {
                        this.$emit('toggleLoader')
                    }
                } else {
                    alert('Fill the fields')
                    this.$emit('toggleLoader');
                }
            } else if (auth == 'login') {
                document.getElementById('close2').click();
                
                const user = await DataService.login({ email: this.email });

                if (user) {
                    this.$store.commit('connect', {_id: user._id, staffType: user.staffType});

                    if (user.staffType == 'Academic Teaching') {
                        this.$router.push({ path: '/sectiona' });
                    } else {
                        this.$router.push({ path: '/section1' })
                    }

                    this.$emit('toggleLoader');
                } else {
                    this.$emit('toggleLoader');
                    alert('user not found in database')
                }
                this.email = ''
            }
            
        }
    }
}
</script>
